/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Specifies the pricing model used for the calculation of the final fee.
 */
export const FeeModel = {
  Fixed: "fixed",
  Blended: "blended",
  Variable: "variable",
} as const;
/**
 * Specifies the pricing model used for the calculation of the final fee.
 */
export type FeeModel = ClosedEnum<typeof FeeModel>;

/** @internal */
export const FeeModel$inboundSchema: z.ZodNativeEnum<typeof FeeModel> = z
  .nativeEnum(FeeModel);
/** @internal */
export const FeeModel$outboundSchema: z.ZodNativeEnum<typeof FeeModel> =
  FeeModel$inboundSchema;
